
<div class="d-flex flex-row-reverse justify-content-between align-items-center">
    <div class="btn-group">
        <button id="editOrder" style="display: block;" class="btn btn-info" (click)="editOrder()">
            <span class="material-icons">
                edit
            </span>
            <span>Editar Orden</span>
        </button>
        <button id="cancelOrder" style="display: none;" class="btn btn-danger" (click)="cancelOrder()">
            <span class="material-icons">
                close
            </span>
            <span>Cancelar</span>
        </button>
        <button id="saveOrder" style="display: none;" class="btn btn-success" (click)="saveOrder()">
            <span class="material-icons">
                save
            </span>
            <span>Guardar Orden</span>
        </button>
        <button class="btn btn-info" (click)="copyIndicators()">
            <span class="material-icons">
                content_copy
            </span>
            <span>Copiar indicadores</span>
        </button>
    </div>
    <div class="form-inline">
        <div class="form-inline">
            Periodo Aqui: {{startPeriod + " - " + endPeriod}}
        </div>
        <div class="form-group">
            <input type="date" class="form-control border-info" (change)="setSelectedDate($event.target.value)">
        </div>
        <div class="btn-group" role="group" *ngIf="togglePeriod">
            <button class="btn btn-outline-info" (click)="getLastWeek()">
                <span class="material-icons">
                    arrow_back
                </span>
            </button>
            <button class="btn btn-outline-info d-flex align-items-center" (click)="getCurrentWeek()">
                <span>
                    Semana
                </span>:
                {{currentWeek}}
            </button>
            <button class="btn btn-outline-info" (click)="getNextWeek()">
                <span class="material-icons">
                    arrow_forward
                </span>
            </button>
        </div>
        <div class="btn-group" role="group" *ngIf="!togglePeriod">
            <button class="btn btn-outline-info" (click)="getLastMonth()">
                <span class="material-icons">
                    arrow_back
                </span>
            </button>
            <button class="btn btn-outline-info d-flex align-items-center" (click)="getCurrentMonth()">
                <span>
                    Mes
                </span>:
                {{returnMonthFormat(currentMonth)}}
            </button>
            <button class="btn btn-outline-info" (click)="getNextMonth()">
                <span class="material-icons">
                    arrow_forward
                </span>
            </button>
        </div>
        <div class="form-inline">
            <span class="material-icons cursor-pointer text-info" *ngIf="togglePeriod"
                (click)="switchDisplayIndicators()">
                toggle_on
            </span>
            <span class="material-icons cursor-pointer text-success" *ngIf="!togglePeriod"
                (click)="switchDisplayIndicators()">
                toggle_off
            </span>
        </div>
    </div>
</div>
<div class="table-responsive-dtroy mt-1" >
  <table class="table align-middle table-bordered table-sm m-0" style="background-color: #5D6B99 !important; color: #FFFFFF !important;">
        <thead>
            <tr>
                <th id="colMov" style="display: none;" class=" movementOrderName">
                    <span>Editar</span>
                </th>
                <th class=" priorityNameCell">
                    <span>Prioridad</span>
                </th>
                <th class="indicatorNameCell ">
                    <span>Indicador</span>
                </th>
                <th class="currencyCell ">
                    <span>Meta</span>
                </th>
                <th class="currencyCell ">
                    <span>Resultado</span>
                </th>
                <th class="gaugeCell ">
                    <span>Estatus</span>
                </th>
                <th class="tendCell ">
                    <span>Tendencia</span>
                </th>
                <th class="causeActionCell1 ">
                    <span>Causa raíz</span>
                </th>
                <th class="causeActionCell ">
                    <span>Acción</span>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td colspan="9">
                    <div *ngFor="let departments of indicators; let departmentIndex = index" id="all" cdkDropList (cdkDropListDropped)="dropDep($event,departments[0][0].departmentName,departmentIndex)" >
                        <div>
                            <div class="box-move" *ngFor="let areas of departments; let areaIndex = index" [cdkDragData]="indicator" cdkDrag style="background-color: #97B0DD !important;color: #1A051D !important;">
                                <div class="placeholder" *cdkDragPlaceholder></div>
                                <tr class="areaRow">
                                    <td class="movementOrder movementOrderName d-none">
                                        <div class="handle" cdkDragHandle >
                                            <svg width="35px" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                                            <path d="M0 0h24v24H0z" fill="none"></path>
                                            </svg>
                                        </div>
                                    </td>
                                    <td style="border: none;">
                                        {{departments[0][0].departmentName}} - {{areas[0].areaName}}
                                    </td>
                                </tr>
                                <div id="all" cdkDropList class="list-container" (cdkDropListDropped)="drop($event,areas[0].areaName)">
                                    <div class="box-move" *ngFor="let indicator of areas; let indicatorIndex = index" [cdkDragData]="indicator" cdkDrag>
                                        <div class="placeholder" *cdkDragPlaceholder></div>
                                        <tr id="{{!mesurements[indicator.id!] ? 'dangerRow' : ''}}"
                                            (dblclick)="addMesurement(indicator, togglePeriod ? 'weekly' : 'monthly')" colspan="8">

                                            <td class="movementOrder movementOrderName d-none" style="background-color: #F4F4F4 !important;">
                                                <div class="handle" cdkDragHandle>
                                                    <svg width="28px" fill="currentColor" viewBox="0 0 28 28">
                                                    <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                                                    <path d="M0 0h24v24H0z" fill="none"></path>
                                                    </svg>
                                                </div>
                                            </td>
                                            <td class="priorityNameCell" style="background-color: #F4F4F4 !important;">
                                                <div class="d-flex w-100 justify-content-center align-content-center">
                                                    <span style="width: 50px;" class="badge {{getClassBadgePriority(indicator.priority!)}}">
                                                        {{indicator.priority}}
                                                    </span>
                                                </div>
                                            </td>
                                            <td class="indicatorNameCell" style="background-color: #F4F4F4 !important;">
                                                <span>
                                                    {{indicator.indicator}}
                                                </span>
                                            </td>
                                            <td class="currencyCell" style="background-color: #F4F4F4 !important;">
                                                <span class="numberCell">
                                                    {{returnChangedFormat(indicator.type!, indicator.monthgoal[monthName]!)}}
                                                </span>
                                            </td>
                                            <td class="currencyCell {{ getClassCell(indicator) }}">
                                                <span class=" numberCell">
                                                    {{returnChangedFormat(indicator.type!, mesurements[indicator.id!] ?
                                                    mesurements[indicator.id!].result :
                                                    0)}}
                                                </span>
                                            </td>
                                            <td class="gaugeCell">
                                                <div class="d-inline-flex">
                                                    <ng-container *ngIf="mesurements[indicator.id!].gaugeChartData">
                                                        <google-chart [type]="'Gauge'" [width]="150" [height]="150"
                                                            [options]="mesurements[indicator.id!].gaugeChartOptions"
                                                            [data]="mesurements[indicator.id!].gaugeChartData">
                                                        </google-chart>
                                                    </ng-container>
                                                    <div class="btn-group-vertical btn-group-sm">
                                                        <button class="btn btn-sm btn-icon.round btn-warning"
                                                            (click)="viewHistoryIndicator(indicator)" ngbTooltip="Historial">
                                                            <span class="material-icons">
                                                                history
                                                            </span>
                                                        </button>
                                                        <button class="btn btn-sm btn-icon.round btn-primary"
                                                            (click)="openPeriod(indicator)" ngbTooltip="Gráficas">
                                                            <span class="material-icons">
                                                                insights
                                                            </span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="tendCell" style="background-color: #F4F4F4 !important;">
                                                <ng-container *ngIf="mesurements[indicator.id].lineChartData">
                                                  <google-chart [type]="'ComboChart'" [width]="350" [height]="100"
                                                                [options]="mesurements[indicator.id].lineChartOptions"
                                                                [data]="mesurements[indicator.id].lineChartData"
                                                                [columns]="mesurements[indicator.id].lineChartColumns">
                                                  </google-chart>


                                                </ng-container>
                                            </td>
                                            <td class="causeActionCell1" style="background-color: #F4F4F4 !important;">
                                                <div class="d-inline-flex justify-content-between w-100">
                                                    <div class="text-area">
                                                        {{mesurements[indicator.id!] ? mesurements[indicator.id!].cause :
                                                        null}}
                                                    </div>
                                                    <div class="btn-group-sm" role="group">
                                                        <button type="button" class="btn btn-sm btn-icon.round btn-info"
                                                            (click)="selectInputFile(indicator, indicatorIndex, true)"
                                                            [disabled]="isUploadingFile" ngbTooltip="Subir archivo"
                                                            *ngIf="mesurements[indicator.id!]">
                                                            <span class="material-icons">
                                                                attach_file
                                                            </span>
                                                        </button>
                                                        <button type="button" class="btn btn-sm btn-icon.round btn-success"
                                                            (click)="downloadFile(mesurements[indicator.id!].urlFileCause!)"
                                                            *ngIf="mesurements[indicator.id!] ? mesurements[indicator.id!].urlFileCause! : false"
                                                            ngbTooltip="Descargar archivo">
                                                            <span class="material-icons">
                                                                download
                                                            </span>
                                                        </button>
                                                        <button type="button" class="btn btn-sm btn-icon.round btn-danger"
                                                            (click)="deleteFile(mesurements[indicator.id!], 'urlFileCause')"
                                                            *ngIf="mesurements[indicator.id!] ? mesurements[indicator.id!].urlFileCause! : false"
                                                            ngbTooltip="Borrar archivo">
                                                            <span class="material-icons">
                                                                delete
                                                            </span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="div-loading" *ngIf="isUploadingCause && currentRow === indicatorIndex">
                                                    <div class="progress">
                                                        <div class="progress-bar bg-success" role="progressbar"
                                                            [ngStyle]="{'width': currentPercentage + '%'}" aria-valuenow="100"
                                                            aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="causeActionCell" style="background-color: #F4F4F4 !important;">
                                                <div class="d-inline-flex justify-content-between w-100">
                                                    <div class="w-100">
                                                        <table class="table table-sm w-100 mb-0">
                                                            <tr>
                                                                <th class="causeActionCell position-relative">Acción</th>
                                                                <th class="position-relative dateActionCell">Fecha</th>
                                                            </tr>
                                                            <tr *ngIf="mesurements[indicator.id!].plan1">
                                                                <td class="causeActionCell">{{mesurements[indicator.id!].plan1}}</td>
                                                                <td class="dateActionCell">{{mesurements[indicator.id!].datePlan1}}</td>
                                                            </tr>
                                                            <tr *ngIf="mesurements[indicator.id!].plan2">
                                                                <td class="causeActionCell"> {{mesurements[indicator.id!].plan2}}</td>
                                                                <td class="dateActionCell">{{mesurements[indicator.id!].datePlan2}}</td>
                                                            </tr>
                                                            <tr *ngIf="mesurements[indicator.id!].plan3">
                                                                <td class="causeActionCell"> {{mesurements[indicator.id!].plan3}}</td>
                                                                <td class="dateActionCell">{{mesurements[indicator.id!].datePlan3}}</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                    <div class="btn-group-sm" role="group">
                                                        <button type="button" class="btn btn-sm btn-icon.round btn-info"
                                                            (click)="selectInputFile(indicator, indicatorIndex, false)"
                                                            [disabled]="isUploadingFile" ngbTooltip="Subir archivo"
                                                            *ngIf="mesurements[indicator.id!]">
                                                            <span class="material-icons">
                                                                attach_file
                                                            </span>
                                                        </button>
                                                        <button type="button" class="btn btn-sm btn-icon.round btn-success"
                                                            (click)="downloadFile(mesurements[indicator.id!].urlFilePlan!)"
                                                            *ngIf="mesurements[indicator.id!] ? mesurements[indicator.id!].urlFilePlan! : false"
                                                            ngbTooltip="Descargar archivo">
                                                            <span class="material-icons">
                                                                download
                                                            </span>
                                                        </button>
                                                        <button type="button" class="btn btn-sm btn-icon.round btn-danger"
                                                            (click)="deleteFile(mesurements[indicator.id!], 'urlFilePlan')"
                                                            *ngIf="mesurements[indicator.id!] ? mesurements[indicator.id!].urlFilePlan! : false"
                                                            ngbTooltip="Borrar archivo">
                                                            <span class="material-icons">
                                                                delete
                                                            </span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="div-loading" *ngIf="isUploadingPlan && currentRow === indicatorIndex">
                                                    <div class="progress-bar bg-success" role="progressbar"
                                                        [ngStyle]="{'width': currentPercentage + '%'}" aria-valuenow="100"
                                                        aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </td>
                                        </tr>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>


<input style="display: none;" type="file"  #fileCause (change)="uploadFileCause($event.target)">

<input style="display: none;" type="file"  #filePlan (change)="uploadFilePlan($event.target)">

<ngx-spinner></ngx-spinner>

<style>

</style>
